// Generated by scripts/generate-india-port-codes.mjs from the UN/LOCODE code list — do not edit by hand.
import type { PortLocation } from './location-types';

// One lazy chunk per state, so a page only downloads its own state's locations.
export const LOCATION_DATA: Record<string, () => Promise<PortLocation[]>> = {
  AP: () => import('./data/ap').then(m => m.LOCATIONS),
  AS: () => import('./data/as').then(m => m.LOCATIONS),
  BR: () => import('./data/br').then(m => m.LOCATIONS),
  CH: () => import('./data/ch').then(m => m.LOCATIONS),
  CT: () => import('./data/ct').then(m => m.LOCATIONS),
  DH: () => import('./data/dh').then(m => m.LOCATIONS),
  DL: () => import('./data/dl').then(m => m.LOCATIONS),
  GA: () => import('./data/ga').then(m => m.LOCATIONS),
  GJ: () => import('./data/gj').then(m => m.LOCATIONS),
  HP: () => import('./data/hp').then(m => m.LOCATIONS),
  HR: () => import('./data/hr').then(m => m.LOCATIONS),
  JH: () => import('./data/jh').then(m => m.LOCATIONS),
  JK: () => import('./data/jk').then(m => m.LOCATIONS),
  KA: () => import('./data/ka').then(m => m.LOCATIONS),
  KL: () => import('./data/kl').then(m => m.LOCATIONS),
  LD: () => import('./data/ld').then(m => m.LOCATIONS),
  MH: () => import('./data/mh').then(m => m.LOCATIONS),
  MP: () => import('./data/mp').then(m => m.LOCATIONS),
  OR: () => import('./data/or').then(m => m.LOCATIONS),
  PB: () => import('./data/pb').then(m => m.LOCATIONS),
  PY: () => import('./data/py').then(m => m.LOCATIONS),
  RJ: () => import('./data/rj').then(m => m.LOCATIONS),
  SK: () => import('./data/sk').then(m => m.LOCATIONS),
  TG: () => import('./data/tg').then(m => m.LOCATIONS),
  TN: () => import('./data/tn').then(m => m.LOCATIONS),
  UP: () => import('./data/up').then(m => m.LOCATIONS),
  UT: () => import('./data/ut').then(m => m.LOCATIONS),
  WB: () => import('./data/wb').then(m => m.LOCATIONS),
};
